<div class="documents-page">
    <div class="container">
        <div class="info-content">
            <div class="info">
                <div class="portalLogo" (click)="gotoHome()" style="cursor: pointer;" title="Home"></div>
                <self-ins-policies-and-request-page></self-ins-policies-and-request-page>
            </div>
            <contacts></contacts>
        </div>
        <div class="main-content">
            <div class="checkbox-row">
                <label class="checkbox-label">
                    <input type="checkbox" id="policyDocs" name="policyDocs" [(ngModel)]="policyDocs"
                    (change)="toggleDocTypes('FILEREG', policyDocs)">
                    {{ _translateService.Keys.DOCUMENTS_POLICY_DOCUMENTS | translate }}
                </label>
                <label class="checkbox-label">
                    <input type="checkbox" id="insuredDocs" name="insuredDocs" [(ngModel)]="insuredDocs"
                    (change)="toggleDocTypes('INSURED', insuredDocs)">
                    {{ _translateService.Keys.DOCUMENTS_INSURED_DOCUMENTS | translate }}
                </label>
            </div>
            <div class="searchBar">
                <input
                    id="search"
                    class="form-input"
                    placeholder="{{ _translateService.Keys.COMMON_SEARCH | translate }}"
                    (keyup)="applyFilter()"
                    [(ngModel)]="gridFilterValue"
                    spellcheck="false"
                />
                <button
                    *ngIf="gridFilterValue && gridFilterValue.length > 0"
                    class="clear-search-btn"
                    (click)="clearSearch()"
                    type="button"
                >
                    <img src="../../../assets/close.svg" alt="clear search" width="16" height="16">
                </button>
                <label
                    for="search"
                    class="form_label"
                >{{ _translateService.Keys.COMMON_SEARCH | translate }}
                </label>
            </div>
            <div class="table-cont mt-2">
                <div class="table-block">
                    <div class="table-wrapper">
                        <table mat-table matSort class="bordered" [dataSource]="documents">
                        <ng-container matColumnDef="fileName">
                            <th mat-header-cell mat-sort-header *matHeaderCellDef>{{ _translateService.Keys.VERIFICATION_TRACTORS_VIN | translate }}</th>
                            <td mat-cell *matCellDef="let file">
                                <a
                                    (click)="download(file.fileLocation, file.iconClass, file.documentId)">{{file.description}}</a>
                            </td>
                        </ng-container>
                        <ng-container matColumnDef="category">
                            <th mat-header-cell mat-sort-header *matHeaderCellDef>{{ _translateService.Keys.DOCUMENTS_CATEGORY | translate }}</th>
                            <td mat-cell *matCellDef="let file">
                                {{ file.categoryDescription }}</td>
                        </ng-container>
                        <ng-container matColumnDef="links">
                            <th mat-header-cell *matHeaderCellDef>{{ _translateService.Keys.DOCUMENTS_ACTION | translate }}</th>
                            <td mat-cell *matCellDef="let file">
                                <div class="links">
                                    <a *ngIf="!(file.iconClass === 'jetfileicon jetfileicon-email' ||
                                                            file.iconClass === 'jetfileicon jetfileicon-note' ||
                                                            file.iconClass === 'jetfileicon jetfileicon-new disabled')"
                                        (click)="download(file.fileLocation, file.iconClass, file.documentId)">
                                        <ng-container>
                                            <img src="../../../assets/img/btn-download-white.png" alt="download">
                                        </ng-container>
                                    </a>
                                </div>
                            </td>
                        </ng-container>
                        <tr mat-header-row *matHeaderRowDef="docCols"></tr>
                        <tr mat-row class="table-row" *matRowDef="let row; columns: docCols;"></tr>
                        <tr class="mat-row" *matNoDataRow>
                            <td class="mat-cell noData text-center" colspan="10">{{ _translateService.Keys.VERIFICATION_TRACTORS_NO_DATA_FILTER | translate: {filter: gridFilterValue} }}</td>
                        </tr>
                    </table>
                    </div>
                </div>
                <div class="table-actions mt-2">
                    <p class="m-0">
                        <a [href]="'mailto:' + supportEmail + '?subject=' + (user?.verificationInfo?.insuredName || '')">
                            {{ _translateService.Keys.VERIFICATION_REPORT | translate }}
                        </a>
                        {{ _translateService.Keys.VERIFICATION_INCORRECT_INFO | translate }}
                    </p>
                    <div class="text-end" *ngIf="documents && documents.data.length > 0">
                        <a (click)="downloadAll()" class="downloadAll">
                            {{ _translateService.Keys.DOCUMENTS_DOWNLOAD_ALL | translate }}
                        </a>
                    </div>
                </div>
            </div>
            <div class="actions pt-3">
                <button class="primary-button"
                    [routerLink]="['/coverage']"
                    [queryParams]="{ qnum: qnum, qsuffix: qsuffix }">
                    {{ _translateService.Keys.COMMON_BACK | translate }}
                </button>
            </div>
        </div>
    </div>
</div>
